// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "lapsed_ads_notice".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "lapsed_ads_notice" table (1:1 with a DB row, on the wire). */
export const lapsedAdsNoticeAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    subscriptionEndedAt: z.string().datetime(),
    campaigns: z.unknown(),
    lastCheckedAt: z.string().datetime().nullable(),
    warnedAt: z.string().datetime().nullable(),
    remindedAt: z.string().datetime().nullable(),
    pauseNoticeAt: z.string().datetime().nullable(),
    pauseNoticeCampaignIds: z.array(z.string()).nullable(),
    pausedAt: z.string().datetime().nullable(),
    pausedCampaignIds: z.array(z.string()).nullable(),
    keepRunning: z.boolean(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=lapsedAdsNotice.js.map